import BaseService from './BaseService'
import { Notification, toast} from "../components/ui";

const ApiService = {
    fetchData(param, notifyError = true) {
        return new Promise((resolve, reject) => {
            BaseService(param)
                .then((response) => {
                    resolve(response)
                })
                .catch((errors) => {
                    if (notifyError) {
                        toast.push(
                            <Notification
                                title={'Não foi possível realizar a operação'}
                                type="danger"
                                duration={3500}
                            >
                                Tente novamente mais tarde.
                            </Notification>,
                            {
                                placement: 'top-center',
                            }
                        )
                    }
                    reject(errors)
                })
        })
    },
}

export default ApiService
